// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2OgH1","inputWrap":"Table_inputWrap__1DwHA","col":"Table_col__reqo0","bmiTooltip":"Table_bmiTooltip__M4lib"};